import { atom } from 'recoil';

export const commerceViewer = atom({
  key: 'commerceViewer',
  default: undefined,
});
